import { SidebarContext } from 'providers/SidebarProvider'
import { useContext } from 'react'

export const useSidebar = () => {
  const context = useContext(SidebarContext)

  if (context == null) {
    throw new Error('useSidebar must be called inside SidebarProvider')
  }

  return context
}
